import { AzarUser } from 'src/types/AzarUser';

export type AuthState = AzarUser;
export const initialAuthState: AuthState =  JSON.parse(typeof window !== 'undefined' ? (window.AzarJs?.getLoginResponseJson() || '{}') : '{}') as AzarUser;
